export enum SubmissionDataTest {
  SUBMISSION_TITLE_CUSTOMER = "SUBMISSION_TITLE_CUSTOMER",
  PSR_CUSTOMER_ELIGIBILITY = "PSR_CUSTOMER_ELIGIBILITY",
  TRY_AGAIN_BUTTON = "TRY_AGAIN_BUTTON",
  DATA_STORED_CUSTOMER = "DATA_STORED_CUSTOMER",
  SUBMISSION_IMAGE_CUSTOMER = "SUBMISSION_IMAGE_CUSTOMER",
}
